export default __webpack_public_path__ + "static/media/checkbox.bc2c82df.svg";